import React from 'react';
import { 
  Redirect
} from 'react-router-dom';
import { connect } from 'react-redux'

import { actions as authActions } from '@modules/auth'

class Logout extends React.Component {
	constructor(props) {
		super(props);

		this.props.logout();
		// console.log(this.props)
	}
	render() {
		return (
			<Redirect to="/login" />
		)
	}
}

function mapDispatchToProps(dispatch) {
	return {
		logout: () => {
			// console.log('logout dispatch!')
			dispatch(authActions.logout('Successfully logged out'))
		}
	}
}

export default connect(undefined, mapDispatchToProps)(Logout)


// WEBPACK FOOTER //
// ./src/scenes/Logout/Logout.jsx